module.exports = __webpack_public_path__ + "static/img/default-product-image-non-radius.6b845236.svg";